module.exports = __webpack_public_path__ + "img/3.f83c1b04.jpg";